<template>
    <email-verification
        :header="$t(`profile.kyc.level1Text`)"
        :title=" $t('kycUserIdentity.details')"
    />
</template>

<script>

// Components
import emailVerification from '@webapp/components/user-details/email-verification.vue';

export default {
    name: 'kyc-email',
    components: {
        emailVerification,
    },
};
</script>